import React, { useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import AfdResults, { AfdData } from "../components/AfdResults";
import DashboardLayout, { LayoutProps } from "../components/DashboardLayout";
import { FaArrowRight } from "react-icons/fa";
import { TbFileCheckFilled } from "react-icons/tb";

interface Props extends LayoutProps {
  uploadPath: string;
}

export default function HomePage({ uploadPath, csrfToken, flash }: Props) {
  const [fileName, setFileName] = useState<string | null>(null);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState<string | null>(null);
  const [afdData,  setAfdData]  = useState<AfdData | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  if (afdData) {
    return (
      // <DashboardLayout userEmail={userEmail} userRole={userRole} logoutPath={logoutPath} csrfToken={csrfToken} navPaths={navPaths} flash={flash}>
      //   <AfdResults
      //     data={afdData}
      //     onBack={() => { setAfdData(null); setFileName(null); setError(null); }}
      //     logoutPath={logoutPath}
      //     userEmail={userEmail}
      //     csrfToken={csrfToken}
      //     hideHeader
      //   />
      // </DashboardLayout>
      <DashboardLayout flash={flash}>
        <div className="max-w-4xl mx-auto mt-8">
          <div className="flex flex-col items-center gap-3 mb-6 card bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg">
              <TbFileCheckFilled size={32} />
            <span className="text-2xl font-semibold text-green-700">
              Arquivo importado com sucesso</span>
            <p>O arquivo foi processado corretamente e os registros foram salvos.</p>
            <div className="flex flex-row">

            <NavLink to="/pontos" className="text-blue-700 hover:underline flex items-center gap-1">conferir <FaArrowRight /></NavLink>
            </div>
          </div>
        </div>
      </DashboardLayout>
    );
  }

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const file = fileInputRef.current?.files?.[0];
    if (!file) return;

    setLoading(true);
    setError(null);

    const formData = new FormData();
    formData.append("afd_file", file);

    try {
      const res = await fetch(uploadPath, {
        method: "POST",
        body: formData,
        headers: { "X-CSRF-Token": csrfToken },
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error ?? "Erro ao processar o arquivo.");
      } else {
        setAfdData(data as AfdData);
      }
    } catch {
      setError("Erro de conexão. Tente novamente.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <DashboardLayout flash={flash}>
      <div className="max-w-xl mx-auto space-y-4">
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
            <h2 className="text-2xl font-semibold text-blue-700 mb-1">Upload do Arquivo AFD</h2>
            <p className="text-gray-500 text-sm mb-6">
              O arquivo deve ser do tipo texto, gerado em relógios de ponto eletrônico adequados
              à Portaria 1510/2009 do MTE.
            </p>
            <hr className="border-gray-200 mb-6" />

            {error && (
              <div className="mb-4 bg-red-50 border border-red-300 text-red-700 px-4 py-3 rounded-lg text-sm">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="mb-5">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Selecione o arquivo AFD (.txt):
                </label>
                <div
                  className="flex rounded-lg overflow-hidden border border-gray-300
                             focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500"
                >
                  <button
                    type="button"
                    onClick={() => fileInputRef.current?.click()}
                    className="flex-shrink-0 bg-gray-100 hover:bg-gray-200 transition-colors
                               text-sm font-medium text-gray-700 px-4 py-2.5 border-r border-gray-300"
                  >
                    Escolher arquivo
                  </button>
                  <span className={`flex-1 px-3 py-2.5 text-sm bg-white truncate select-none
                                   ${fileName ? "text-gray-800" : "text-gray-400"}`}>
                    {fileName ?? "Nenhum arquivo selecionado"}
                  </span>
                  <button
                    type="submit"
                    disabled={loading || !fileName}
                    className="flex-shrink-0 flex items-center gap-1.5 bg-blue-600 hover:bg-blue-700
                               active:bg-blue-800 text-white text-sm font-semibold px-4 py-2.5
                               border-l border-blue-700 transition-colors duration-150
                               disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {loading ? (
                      <>
                        <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth={4} />
                          <path className="opacity-75" fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                        </svg>
                        <span>Enviando...</span>
                      </>
                    ) : (
                      <>
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                        </svg>
                        <span>Enviar</span>
                      </>
                    )}
                  </button>
                </div>
                <input
                  ref={fileInputRef}
                  type="file"
                  name="afd_file"
                  accept=".txt,.afd"
                  required
                  className="sr-only"
                  onChange={e => setFileName(e.target.files?.[0]?.name ?? null)}
                />
              </div>
            </form>
          </div>
        </div>
    </DashboardLayout>
  );
}

